export const iframeArenaEnvironmentsDev = [{ name: 'Dev', value: 'dev' }];

export const iframeArenaEnvironmentsProd = [
    { name: 'Canary', value: 'canary' },
    { name: 'Production', value: 'prod' },
];

export const iframeArkcomEnvironmentsDev = [{ name: 'Dev', value: 'dev' }];

export const iframeArkcomEnvironmentsProd = [
    { name: 'Staging', value: 'stage' },
    { name: 'Production', value: 'prod' },
];
export const iframeAarpEnvironmentsDev = [{ name: 'Stage', value: 'stage' }];

export const iframeAarpEnvironmentsProd = [{ name: 'Production', value: 'prod' }];
